// All app-UI languages (distinct from FLYER_LANGS in flyerI18n.js, which is
// scoped to marketing-flyer copy only). Shares the same `preferred_language`
// field on the user doc as the flyer picker, so one choice drives both.
export const APP_LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिंदी" },
  { code: "mr", label: "मराठी" },
  { code: "gu", label: "ગુજરાતી" },
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" },
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "bn", label: "বাংলা" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
  { code: "ml", label: "മലയാളം" },
];
